import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  getQontoStatus,
  disconnectQonto,
  refreshQontoToken,
  getQontoAuthUrl,
} from '@/services/qontoApi'

/**
 * Check Qonto OAuth connection status
 */
export function useQontoConnectionStatus() {
  return useQuery({
    queryKey: ['qonto', 'connection-status'],
    queryFn: getQontoStatus,
    staleTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}

/**
 * Start OAuth flow — fetches authorization URL from backend, then redirects browser
 */
export function useQontoConnect() {
  const mutation = useMutation({
    mutationFn: async () => {
      const url = await getQontoAuthUrl()
      window.location.href = url
    },
  })

  return {
    connect: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
  }
}

/**
 * Disconnect Qonto
 */
export function useQontoDisconnect() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: disconnectQonto,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['qonto'] })
    },
  })
}

/**
 * Force refresh the OAuth token
 */
export function useQontoRefreshToken() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: refreshQontoToken,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['qonto', 'connection-status'] })
    },
  })
}
